export default __webpack_public_path__ + "static/media/FINGER_print.cdee1fa3.gif";